<template>
	<div>
		<v-card>
			<v-card-title class="mt-3 mb-3">
				<h2>Parametry oceny</h2>
				<v-spacer/>
			</v-card-title>
			<v-btn class="ml-3 mt-2"
				primary @click="saveSettings()">Zapisz
			</v-btn>
			<v-card-text>
				<v-spacer></v-spacer>
				<br/>
				<v-layout row>
					<v-flex xs4>
						<div class="ml-3" style="font-weight: bold;">
							{{ ratingSettings.booleanEvaluation === true ? "Ocena tak/nie" : "Ocena punktowa"}}
						</div>
					</v-flex>
					<v-flex xs12 sm7>
						<v-btn
							:disabled="contestData.evaluationOpen || contestData.evaluationFinished"
							flat icon color="green" @click="changeBooleanEvaluation()">
							<v-icon>cached</v-icon>
						</v-btn>
						<v-tooltip bottom max-width="480px">
							<template v-slot:activator="{ on }">
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								Zmiana typu oceny po rozpoczęciu opiniowania nie jest możliwa.
								Przed taką zmianą konieczne jest skasowanie wszystkich przypisanych wcześniej ocen merytorycznych i końcowych,
								a następnie ich ponowne przypisanie opiniującym. Przed skasowaniem oceny należy pamiętać o skopiowaniu jej treści.
							</span>
						</v-tooltip>
					</v-flex>
				</v-layout>
				<v-expand-transition>
					<egranty-table
						v-show="ratingSettings.booleanEvaluation !== true && ratingParamsAppliable === true"
						:table-name="'Parametry oceny indywidualnej opinii członka zespołu'"
						:items="table.ratingParameters"
						:headers="table.headers"
						:toolbar-action-name="'Dodaj parametr oceny'"
						:row-actions="table.actions"
						@toolbarAction="addParameterDialogVisible = true"
						@edit="editRatingParameter"
						@delete="deleteRatingParameter"
					></egranty-table>
				</v-expand-transition>
				<div v-if="ratingParamsAppliable !== true && ratingSettings.booleanEvaluation !== true">
					Formularz indywidualnej opinii członka komisji nie został wybrany dla tego konkursu, więc parametry
					indywidualnej opinii zostały ukryte.
				</div>
				<contest-rating-parameters-dialog
					:show-dialog.sync="addParameterDialogVisible"
					:edited-item="editedItem"
					@save="addRatingParameter"
				/>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import EgrantyTable from "../../../genericComponents/EgrantyTable";
	import ContestRatingParametersDialog from "../contest/components/ContestRatingParametersDialog";

	export default {
		name: "AgencyContestRatingParametersSettingsView",
		components: {EgrantyTable, ContestRatingParametersDialog},
		data () {
			return {
				ratingParamsAppliable: false,
				ratingSettings: {
					booleanEvaluation: false,
				},
				addParameterDialogVisible: false,
				table: {
					headers: [
						{text: "Nazwa kryterium", value: "criteriaName"},
						{text: "Minimalna wartość", value: "minRating"},
						{text: "Maksymalna wartość", value: "maxRating"},
						{text: "Mnożnik", value: "multiplier"},
					],
					ratingParameters: [],
					actions: [
						{name: "edit", icon: "edit"},
						{name: "delete", icon: "delete"},
					],
				},
				contestData: {
					id: this.$route.params.id,
					evaluationOpen: undefined,
					evaluationFinished: undefined
				},
				editedItem: undefined,
        initialEvaluationIsBoolean: false,
			};
		},

		beforeMount () {
			this.update();
			this.checkParamsAppliability();
			AgencyContest.getState(this, this.contestData.id,
				response => {
					this.contestData.evaluationOpen = response.agencyContestStatus === 'STARTED';
					this.contestData.evaluationFinished = response.agencyContestStatus === 'FINISHED';
				});
		},

		methods: {
			changeBooleanEvaluation () {
				this.ratingSettings.booleanEvaluation =
					!(this.ratingSettings.booleanEvaluation);
			},

      saveSettings() {
        if (this.initialEvaluationIsBoolean !== this.ratingSettings.booleanEvaluation) {
          AgencyContest.getIsSubstantiveOrFinalEvaluationPresent(this, this.$route.params.id, successResponse => {
            if (successResponse) {
              this.$messagesBus.$emit("error", "Aby zmienić typ oceny, należy usunąć przypisane oceny merytoryczne i końcowe");
            } else {
              this.putRatingSettings();
            }
          }, () => {
            this.$messagesBus.$emit("error", "Nie udało się zwalidować ocen");
          });
        }
        else {
          this.putRatingSettings();
        }
      },

      putRatingSettings () {
				AgencyContest.putRatingSettings(this, this.$route.params.id, this.ratingSettings, () => {
					this.$messagesBus.$emit("success", "Parametry oceny zostały pomyślnie zapisane");
					this.loadRatingSettings();
				}, () => {
          this.$messagesBus.$emit("error", "Nie udało się zapisać parametrów oceny");
        });
			},

			loadRatingSettings () {
				AgencyContest.getRatingSettings(this, this.$route.params.id, response => {
					this.ratingSettings = response.ratingSettings;
          this.initialEvaluationIsBoolean = response.ratingSettings.booleanEvaluation;
        });
			},

			getRatingParameters () {
				AgencyContest.getRatingParameters(this, this.$route.params.id, response => {
					this.table.ratingParameters = response;
				});
			},

			addRatingParameter (newParam) {
				if (!this.editedItem) {
					this.createRatingParameter(newParam);
				} else {
					this.updateRatingParameter(newParam);
				}
			},

			editRatingParameter (item) {
				this.editedItem = Object.assign({}, item);
				this.addParameterDialogVisible = true;
			},

			createRatingParameter (newParam) {
				newParam.agencyContestId = this.$route.params.id;
				AgencyContest.postRatingParameter(this, newParam, successResponse => {
						this.addParameterDialogVisible = false;
						this.$messagesBus.$emit("success", "Parametr oceny został pomyślnie dodany", successResponse);
						this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się dodać parametru oceny", errorResponse);
					});
			},

			updateRatingParameter (newParam) {
				newParam.agencyContestId = this.$route.params.id;
				AgencyContest.putRatingParameter(this, newParam, successResponse => {
						this.addParameterDialogVisible = false;
						this.$messagesBus.$emit("success", "Parametr oceny został pomyślnie zmieniony", successResponse);
						this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					});
				this.editedItem = undefined;
			},

			deleteRatingParameter (item) {
				AgencyContest.deleteRatingParameter(this, this.$route.params.id, item.id, successResponse => {
						this.$messagesBus.$emit("success", "Parametr oceny został pomyślnie usunięty", successResponse);
						this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					});
			},

			checkParamsAppliability () {
				AgencyContest.getAllForms(this, this.$route.params.id, response => {
					this.ratingParamsAppliable = response.agencyContestSchemaSet.individualEvaluationSchemaIncluded;
				});
			},

			update () {
				this.loadRatingSettings();
				if (this.ratingSettings.booleanEvaluation !== true) {
					this.getRatingParameters();
				}
			},
		},
	};
</script>

<style scoped>

</style>
